/* eslint-disable max-len */
import React, { useRef } from 'react';
import AnimatedModel from '../Animation/AnimatedModel';
import AnimatedHeading from '../Animation/AnimatedHeading';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import AnimatedButton from '../Animation/AnimatedButton';

const ConfirmationModel = ({
    handleClose, 
    tittle, 
    message, 
    buttonName, 
    handleOnCLickActivate, 
    loadingActivation,
    crossMark,
    ignoreOutsideClick,
    dialogueWidth,
    additionalMessage}) => {
    const outsideClickRef = useRef();
    useOnClickOutside(outsideClickRef, () => {
        if (ignoreOutsideClick === undefined) handleClose();
    });
    
    dialogueWidth = dialogueWidth ? dialogueWidth : '500px';
    return (
        <AnimatedModel 
            Children={
                <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabindex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{display: "block"}}>
                    <div ref={outsideClickRef} data-te-modal-dialog-ref="" className={`pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-${dialogueWidth} mx-auto max-w-${dialogueWidth}`}>
                        <div className="pointer-events-auto flex flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600 mx-auto px-6 py-4 relative">
                            <div className={`relative ${crossMark ? "mt-6" : "pt-1"}`}>
                                {(additionalMessage !== "" && additionalMessage !== undefined) && <AnimatedHeading className="text-center mb-3" Children={additionalMessage} /> }
                                <AnimatedHeading className="text-center" Children={message} />
                            </div>
                            <div className="flex mt-4 w-fit mx-auto">
                                <AnimatedButton
                                    handleClick={() => handleClose()} 
                                    className="actn-btn1" 
                                    buttonName={buttonName}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
        
    );
}

export default ConfirmationModel;
